export enum RelativeMonth {
  NEXT_MONTH = 'NEXT_MONTH',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
}
